import SponsorsGridItem from './SponsorsGridItem'
export default function SponsorsGrid({ sponsors }) {
  return (
    <div className="grid grid-cols-12 gap-2">
      {sponsors?.map((sponsor) => (
        <SponsorsGridItem
          key={sponsor.id}
          sponsor={sponsor}
        />
      ))}
    </div>
  )
}
